export const getAlertInfo = (req) => {
    const requestOptions = {
        method: 'GET'
    };
    return fetch('/shared/api/getAlertInfo', requestOptions).then((response) => response.json())
}